import { Helmet } from "react-helmet";

const Meta = () => {
  return (
    <Helmet>
      <title>Randi.ai - Kontakt oss</title>
      <meta name="thumbnail" content="https://randi.ai/showcase.jpg" />
      <meta name="robots" content="index, follow" />
      <meta
        name="description"
        content="Har du et spørsmål eller ønsker å komme i kontakt med oss av en annen grunn? Benytt deg av kontaktskjemaet nedenfor så kommer vi tilbake til deg."
      />
      <meta name="author" content="Randi.ai" />
      <meta
        name="keywords"
        content="Har du et spørsmål eller ønsker å komme i kontakt med oss av en annen grunn? Benytt deg av kontaktskjemaet nedenfor så kommer vi tilbake til deg."
      />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:url" content="https://randi.ai/" />
      <meta name="twitter:title" content="Randi.ai - Kontakt oss" />
      <meta name="twitter:description" content="" />
      <meta name="twitter:image" content="https://randi.ai/showcase.jpg" />

      <meta property="og:url" content="https://randi.ai/" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Randi.ai - Kontakt oss" />
      <meta
        property="og:description"
        content="Har du et spørsmål eller ønsker å komme i kontakt med oss av en annen grunn? Benytt deg av kontaktskjemaet nedenfor så kommer vi tilbake til deg."
      />
      <meta property="og:image" content="https://randi.ai/showcase.jpg" />
      <link rel="canonical" href="https://randi.ai/" />
    </Helmet>
  );
};

export default Meta;
